module.exports = __webpack_public_path__ + "img/h-vimeo.5986f08c.svg";